// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.estimates-controls{margin-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/react/components/Datacenter/EstimatesReport/EstimatesReport.css"],"names":[],"mappings":"AAAA,oBACE,iBAAA","sourcesContent":[".estimates-controls {\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
